import React, { useState, useEffect } from 'react';
import { getNews } from '../api/news';
import './newsDetail.scss';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import Header from '../components/headerBar';
import Footer from '../components/footer';

interface INews {
  content: string;
  id: number;
  title: string;
  type: number;
  publishDate: string;
  next?: {
    title: string;
    id: number;
  };
  previous?: {
    title: string;
    id: number;
  };
}

const map = Object.freeze({
  a: {
    en: 'ALL',
    'zh-cn': '全部资讯',
  },
  b: {
    en: 'HOT',
    'zh-cn': '热门活动',
  },
  c: {
    en: 'NEWS',
    'zh-cn': '公司动态',
  },
  d: {
    en: 'FOCUS',
    'zh-cn': '行业焦点',
  },
  e: {
    en: 'News',
    'zh-cn': '新闻资讯',
  },
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const NewsDetail = () => {
  const history = useHistory();
  const location = useLocation();
  const [news, setNews] = useState<INews>({
    type: 1,
    content: '',
    publishDate: '',
    id: 0,
    title: '',
  });
  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');

  const query = useQuery();
  const { id } = useParams();
  useEffect(() => {
    getNews(id).then((res) => {
      if (res.status === 200) {
        setNews(res.data);
      }
    });
  }, [location.pathname]);

  const goDetail = (id?: number) => {
    if (id) {
      history.push('/' + la + '/news/' + id);
    }
  };

  const goNews = (type?: number) => {
    if (type) {
      query.set('type', type.toString());
    }
    history.push('/' + la + '/news?' + query.toString());
  };

  const { lang } = useParams();

  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  return (
    <div id='news-detail'>
      <Header></Header>
      <ul className='bread-crumbs'>
        <li onClick={() => goNews()}>{map.e[la]} &gt; &nbsp;</li>
        <li onClick={() => goNews(news.type)}>
          {news?.type === 1 ? map.b[la] : news.type === 2 ? map.c[la] : map.d[la]} &gt;&nbsp;{' '}
        </li>
        <li>{news?.title}</li>
      </ul>

      <div className='news-detail-content'>
        <p className='title'>{news?.title}</p>
        <p className='ctime'>{news?.publishDate}</p>
        <div className='content' dangerouslySetInnerHTML={{ __html: news.content }}></div>
      </div>
      <div className='function-container'>
        <div className='prev' onClick={() => goDetail(news.previous?.id)}>
          上一篇：{news.previous?.title || '无'}
        </div>
        <div className='next' onClick={() => goDetail(news.next?.id)}>
          下一篇：{news.next?.title || '无'}
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default NewsDetail;
